import React from 'react';

import ActivityIndicator from '../../Components/ActivityIndicator';

import Programs from '../../Assets/v2/ThreeHundred/Programs.jpg';
import PlacementSelection from '../../Assets/v2/ThreeHundred/PlacementSelection.jpg';

class Process extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  onImageLoad = () => {
    this.setState({
      isLoading: false
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="th-process-img-box">
          <picture>
            <source srcSet={Programs} media="(min-width: 768px)" />

            <source srcSet={Programs} media="(min-width: 300px)" />
            <img
              onLoad={this.onImageLoad}
              className="th-process-img"
              src={Programs}
              alt="Programs"
            />
          </picture>

          {this.state.isLoading && (
            <div className="th-process-loader">
              <ActivityIndicator size="large" />
            </div>
          )}
        </div>
        <div className="th-process-img-box">
          <picture>
            <source srcSet={PlacementSelection} media="(min-width: 768px)" />

            <source srcSet={PlacementSelection} media="(min-width: 300px)" />
            <img
              onLoad={this.onImageLoad}
              className="th-process-img"
              src={PlacementSelection}
              alt="Process"
            />
          </picture>

          {this.state.isLoading && (
            <div className="th-process-loader">
              <ActivityIndicator size="large" />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default Process;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Process.js